import { createFileRoute } from "@tanstack/react-router";
import { Preisatlas } from "../features/shell/Preisatlas";

export const Route = createFileRoute("/preisatlas")({
  component: Preisatlas,
});
